import {
    BLOCKUNBLOCKSUBADMINLIST_SUCCESS,
    BLOCKUNBLOCKSUBADMINLIST_FAILED,
    RESET_BLOCKUNBLOCKSUBADMINLIST,
    LOADING_BLOCKUNBLOCKSUBADMINLIST,
    NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetBlockUnblockSubAdminList = () => {
    return { type: RESET_BLOCKUNBLOCKSUBADMINLIST };
};

const BlockUnblockSubAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BLOCKUNBLOCKSUBADMINLIST });
    await adminServices
        .post("BlockUnBlocksubadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(BlockUnblockSubAdminListsuccess(res.data));
                    break;
                default:
                    dispatch(BlockUnblockSubAdminListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST,
                payload: err
            });
        });
};


function BlockUnblockSubAdminListsuccess(data) {
    return {
        type: BLOCKUNBLOCKSUBADMINLIST_SUCCESS,
        payload: data
    };
}
function BlockUnblockSubAdminListFailed(data) {
    return {
        type: BLOCKUNBLOCKSUBADMINLIST_FAILED,
        payload: data
    };
}

export { BlockUnblockSubAdminLists, resetBlockUnblockSubAdminList }